class AnnouncementBarDs extends HTMLElement {
  connectedCallback() {
    this.slider  = this.querySelector('[data-slider]');
    this.slides  = Array.from(this.querySelectorAll('[data-slide]'));
    this.btnPrev = this.querySelector('[data-prev]');
    this.btnNext = this.querySelector('[data-next]');
    this.index   = 0;
    this.total   = this.slides.length;
    this.auto    = this.dataset.autoscroll === 'true';
    this.speed   = parseInt(this.dataset.speed || '4', 10) * 1000;
    this.timer   = null;

    if (this.total < 2) return;

    this._buildInfinite();

    this.btnPrev && this.btnPrev.addEventListener('click', () => this.go(-1));
    this.btnNext && this.btnNext.addEventListener('click', () => this.go(1));

    this._initSwipe();
    if (this.auto) this._startTimer();
  }

  _buildInfinite() {
    const first = this.slides[0].cloneNode(true);
    const last  = this.slides[this.total - 1].cloneNode(true);
    this.slider.appendChild(first);
    this.slider.insertBefore(last, this.slides[0]);

    this._setTransform(1, false);
    this._realIndex = 1;
  }

  go(dir) {
    this._realIndex += dir;
    this._setTransform(this._realIndex, true);
    if (this.auto) { clearInterval(this.timer); this._startTimer(); }
  }

  _setTransform(extIndex, animate) {
    if (!this.slider) return;
    this.slider.style.transition = animate ? 'transform 0.4s ease' : 'none';
    this.slider.style.transform  = `translateX(${-extIndex * 100}%)`;
    if (animate) {
      this.slider.addEventListener('transitionend', () => this._checkBounds(), { once: true });
    }
  }

  _checkBounds() {
    const extTotal = this.total + 2;
    if (this._realIndex >= extTotal - 1) {
      this._realIndex = 1;
      this._setTransform(1, false);
    } else if (this._realIndex <= 0) {
      this._realIndex = this.total;
      this._setTransform(this.total, false);
    }
  }

  _startTimer() {
    this.timer = setInterval(() => this.go(1), this.speed);
  }

  _initSwipe() {
    let startX = 0;
    this.addEventListener('touchstart', e => { startX = e.touches[0].clientX; }, { passive: true });
    this.addEventListener('touchend', e => {
      const diff = startX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 40) this.go(diff > 0 ? 1 : -1);
    }, { passive: true });
  }
}

if (!customElements.get('announcement-bar-ds')) {
  customElements.define('announcement-bar-ds', AnnouncementBarDs);
}
